<template>
  <div>
    <component
      :is="$register ? 'q-item' : 'q-expansion-item'"
      clickable
      :default-opened="($isLandscapeView() && (order.availableRewards.length > 0 || order.availableDiscounts.length > 0)) || $q.screen.xs || !$isLandscapeView()"
      :header-class="$register ? '' : 'bg-responsive-grey-3 q-px-sm'"
      expand-separator
      data-test-id="redemptions"
      @click="redemptionsDialog = true"
    >
      <template v-if=" $register">
        <q-item-section
          avatar
        >
          <q-avatar
            :color="$register ? 'primary' : undefined"
            :text-color="$register ? 'white' : 'responsive'"
            icon="fal fa-light fa-award"
          />
        </q-item-section>
        <q-item-section>
          <q-item-label
            :class="$register ? 'text-weight-bold text-subtitle1 text-primary' : 'text-h6'"
          >
            Redemptions
            <template v-if="order.unappliedVouchers.length || order.availableRewards.length || order.availableDiscounts.length">
              Available
            </template>
          </q-item-label>
          <q-item-label
            v-if="order.user && loggedIn"
            caption
            lines="2"
          >
            <template v-if="order.pointsToUse > 0">
              Using <b class="text-responsive">{{ order.pointsToUse }}</b> of <b class="text-responsive">{{ order.totalPoints || 0 }} {{ currentCircuit.rewardsCurrencyName || $tc('user.point', 2) }} </b>.
            </template>
            <template v-else>
              <b class="text-responsive">{{ order.availablePoints || 0 }}  {{ currentCircuit.rewardsCurrencyName || $tc('user.point', 2) }} </b> available to spend.
            </template>
          </q-item-label>
        </q-item-section>
        <q-item-section side>
          <q-icon
            name="arrow_forward_ios"
            color="chevron_right"
            @click="redemptionsDialog = true"
          />
        </q-item-section>
      </template>
      <template
        #header
      >
        <q-item-section
          avatar
          style="max-width: 44px; min-width: 44px;"
        >
          <q-avatar
            text-color="responsive"
            icon="fal fa-light fa-award"
          />
        </q-item-section>
        <q-item-section>
          <q-item-label
            :class="$q.screen.gt.xs ? 'text-h6' : 'text-weight-bolder text-body1'"
          >
            {{ $t('checkout.steps.redemptions') }}
            <template v-if="order.unappliedVouchers.length || order.availableRewards.length || order.availableDiscounts.length">
              {{ $t('status.available') }}
            </template>
          </q-item-label>
          <q-item-label
            v-if="order.user && loggedIn"
            caption
            lines="2"
          >
            <i18n-t
              v-if="order.pointsToUse > 0"
              keypath="pages.redemptions.usingRewards"
              scope="global"
            >
              <template #count>
                <b class="text-responsive">{{ order.pointsToUse }}</b>
              </template>
              <template #currencyName>
                <b class="text-responsive">{{ order.totalPoints || 0 }} {{ currentCircuit.rewardsCurrencyName || $tc('user.point', order.totalPoints || 0) }} </b>.
              </template>
            </i18n-t>
            <i18n-t
              v-else
              keypath="pages.redemptions.rewardsAvailable"
              scope="global"
            >
              <template #count>
                <b class="text-responsive">{{ order.availablePoints || 0 }}</b>
              </template>
              <template #currencyName>
                <b class="text-responsive">{{ currentCircuit.rewardsCurrencyName || $tc('user.point', order.totalPoints || 0) }}</b>
              </template>
            </i18n-t>.
          </q-item-label>
        </q-item-section>
      </template>
      <template v-if="!loggedIn">
        <div
          class="justify-center text-center q-px-md q-px-md q-pa-sm row text-body1"
          style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
        >
          <q-btn
            :label="$t('auth.actions.signup')"
            class="text-underline"
            flat
            padding="none xs"
            dense
            @click="$emit('register')"
          />
          {{ $t('common.or') }}
          <q-btn
            :label="$t('auth.actions.login')"
            class="text-underline"
            flat
            padding="none xs"
            dense
            @click="$emit('login')"
          />
          {{ $t('pages.redemptions.toEarnRewardsCurrencyWithEveryPurchase', { currencyName: currentCircuit.rewardsCurrencyName || $tc('user.point', 2) }) }}
        </div>
        <div
          class="justify-center q-px-md q-px-md q-pa-sm row text-subtitle2"
          style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
        >
          {{ $t('pages.redemptions.rewardsIncludeHeading', { currencyName: currentCircuit.rewardsCurrencyName || $tc('user.point', 2) }) }}
        </div>
      </template>
      <component
        :is="$register ? 'q-dialog' : 'div'"
        v-if="showRedemptionsDetail"
        v-model="redemptionsDialog"
        data-test-id="redemptions-dialog"
        class="q-pb-md"
      >
        <q-card
          class="no-shadow"
          :class="$register ? 'q-pb-xl q-px-sm' : undefined"
        >
          <q-card-section
            v-if="$register"
            class="row items-center q-pb-none"
          >
            <q-btn
              v-if="$q.screen.lt.sm "
              v-close-popup
              icon="chevron_left"
              flat
              round
              dense
            />
            <div class="text-h6">
              {{ $t('pages.redemptions.redemptions') }}
              <template v-if="order.unappliedVouchers.length || order.availableRewards.length || order.availableDiscounts.length">
                {{ $t('status.available') }}
              </template>
            </div>
            <template v-if="$q.screen.gt.xs">
              <q-space />
              <q-btn
                v-close-popup
                icon="close"
                flat
                round
                dense
              />
            </template>
          </q-card-section>
          <q-item
            class="q-py-none justify-evenly"
            dense
          >
            <q-item-section>
              <div class="row justify-center items-start q-gutter-xs q-py-xs">
                <div
                  v-if="$register"
                  class="text-subtitle2 full-width q-px-sm q-py-sm text-grey"
                  style="line-height: 1.1;"
                >
                  <template v-if="order.pointsToUse > 0">
                    You will use <span style="color: red">{{ order.pointsToUse }}  {{ currentCircuit.rewardsCurrencyName || $tc('user.point', 2) }} </span> at this order.
                  </template>
                  You have <span style="color: red">{{ order.availablePoints || 0 }}  {{ currentCircuit.rewardsCurrencyName || $tc('user.point', 2) }} </span> available to spend.
                </div>
                <q-banner
                  v-for="reward in order.availableRewards"
                  :key="'reward' + reward.id"
                  inline-actions
                  rounded
                  dense
                  class="full-width"
                  :clickable="!viewOnly"
                  data-test-id="reward-banner"
                  @click="order.applyReward(reward)"
                >
                  <div class="column">
                    <div
                      class="text-subtitle1 text-weight-bold"
                      style="line-height: 1.25"
                    >
                      {{ reward.name }}
                      <q-icon
                        v-if="reward.description"
                        name="info"
                        color="grey"
                      >
                        <q-tooltip>
                          {{ reward.description }}
                        </q-tooltip>
                      </q-icon>
                    </div>
                    <div
                      class="text-caption"
                      style="line-height: 1"
                    >
                      {{ reward.pointsCost }} {{ currentCircuit.rewardsCurrencyName || $tc('user.point', 2) }}
                    </div>
                  </div>

                  <template #action>
                    <div class="row justify-center items-center q-gutter-x-sm">
                      <template
                        v-for="voucher in order.uniqueAppliedVouchers"
                      >
                        <q-btn
                          v-if="voucher.isReward && voucher.voucherType.name === reward.name"
                          :key="voucher.typeName + voucher.id"
                          :color="$register ? undefined : 'responsive-grey-2'"
                          text-color="responsive"
                          :round="!$register"
                          :outline="$register"
                          dense
                          :icon="numberOfRewardRedeemed(order, reward) > 1 ? 'fal fa-minus' : 'fal fa-trash-can'"
                          @click.stop="voucher.autoApply = false; order.applyRedemptions()"
                        />
                      </template>
                      <div v-if="rewardRedeemed(order, reward)">
                        {{ numberOfRewardRedeemed(order, reward) }}
                      </div>
                      <q-btn
                        :color="rewardRedeemed(order, reward) ? $register ? undefined : 'responsive-grey-2' : 'secondary'"
                        :text-color="rewardRedeemed(order, reward) ? 'responsive' : undefined "
                        :round="!$register && rewardRedeemed(order, reward)"
                        :rounded="!rewardRedeemed(order, reward)"
                        :outline="$register && rewardRedeemed(order, reward)"
                        :icon="rewardRedeemed(order, reward) ? 'fal fa-plus' : undefined"
                        :dense="rewardRedeemed(order, reward)"
                        @click.stop="(event) => !event.qKeyEvent && order.applyReward(reward)"
                      >
                        {{ rewardRedeemed(order, reward) ? undefined : 'Apply' }}
                      </q-btn>
                    </div>
                  </template>
                </q-banner>

                <q-banner
                  v-for="vouchers in order.unappliedVouchers"
                  :key="vouchers.firstVoucher.id"
                  inline-actions
                  rounded
                  dense
                  class="full-width"
                  :clickable="!viewOnly"
                  :removable="!viewOnly && vouchers.firstVoucher.isManual && !vouchers.firstVoucher.isUnlimited"
                  @click="$emit('apply-voucher', vouchers)"
                  @remove="order.independentVouchers.remove(vouchers.firstVoucher); order.applyVoucher(vouchers.firstVoucher)"
                >
                  <div class="column">
                    <div
                      class="text-subtitle1 text-weight-bold"
                      style="line-height: 1.25"
                    >
                      {{ vouchers.firstVoucher.voucherType.name }} {{ vouchers.count > 1 ? (' - ' + vouchers.count) : '' }}
                    </div>
                  </div>

                  <template #action>
                    <q-btn
                      v-if="voucherCanBeApplied(vouchers.firstVoucher)"
                      rounded
                      :icon-right="voucherRedeemed(order, vouchers.firstVoucher) ? 'done' : undefined"
                      :color="voucherRedeemed(order, vouchers.firstVoucher) ? 'primary' : 'secondary'"
                      :label="voucherRedeemed(order, vouchers.firstVoucher) ? $t('actions.applied') : $t('actions.apply')"
                    />
                    <q-btn
                      v-else
                      rounded
                      color="responsive-grey-2"
                      :label="$t('status.unavailable')"
                      text-color="responsive-grey-7"
                      size="sm"
                    />
                  </template>
                </q-banner>

                <template v-if="order.user || !loggedIn">
                  <q-banner
                    v-for="rewardValidation in unavailableRewardsWithValidation"
                    :key="'reward' + rewardValidation.reward.id"
                    inline-actions
                    rounded
                    dense
                    class="full-width"
                  >
                    <div class="column">
                      <div
                        class="text-subtitle1 text-weight-bold"
                        style="line-height: 1.25"
                      >
                        {{ rewardValidation.reward.name }}
                        <q-icon
                          v-if="rewardValidation.reward.description"
                          name="info"
                          color="grey"
                        >
                          <q-tooltip>
                            {{ rewardValidation.reward.description }}
                          </q-tooltip>
                        </q-icon>
                      </div>
                      <div
                        class="text-caption"
                        style="line-height: 1"
                      >
                        {{ rewardValidation.reward.pointsCost }} {{ currentCircuit.rewardsCurrencyName || $tc('user.point', 2) }}
                      </div>
                    </div>

                    <template
                      v-if="loggedIn"
                      #action
                    >
                      <div
                        v-if="rewardRedeemed(order, rewardValidation.reward)"
                        class="row justify-center items-center q-gutter-x-sm"
                      >
                        <template
                          v-for="voucher in order.uniqueAppliedVouchers"
                        >
                          <q-btn
                            v-if="voucher.isReward && voucher.voucherType.name === rewardValidation.reward.name"
                            :key="voucher.typeName + voucher.id"
                            :color="$register ? undefined : 'responsive-grey-2'"
                            text-color="responsive"
                            :round="!$register"
                            :outline="$register"
                            dense
                            :icon="numberOfRewardRedeemed(order, rewardValidation.reward) > 1 ? 'fal fa-minus' : 'fal fa-trash-can'"
                            @click.stop="voucher.autoApply = false; order.applyRedemptions()"
                          />
                        </template>
                        <div>
                          {{ numberOfRewardRedeemed(order, rewardValidation.reward) }}
                        </div>
                        <q-btn
                          :color="rewardRedeemed(order, rewardValidation.reward) ? $register ? undefined : 'responsive-grey-2' : 'secondary'"
                          :text-color="rewardRedeemed(order, rewardValidation.reward) ? 'responsive' : undefined "
                          :round="!$register && rewardRedeemed(order, rewardValidation.reward)"
                          :rounded="!rewardRedeemed(order, rewardValidation.reward)"
                          :outline="$register && rewardRedeemed(order, rewardValidation.reward)"
                          :icon="rewardRedeemed(order, rewardValidation.reward) ? 'fal fa-plus' : undefined"
                          :dense="rewardRedeemed(order, rewardValidation.reward)"
                          disable
                        />
                      </div>
                      <q-btn
                        v-else
                        rounded
                        color="responsive-grey-2"
                        :label="$t('status.unavailable')"
                        text-color="responsive-grey-7"
                        size="sm"
                      >
                        <q-tooltip v-if="rewardValidation.reason">
                          {{ rewardValidation.reason }}
                        </q-tooltip>
                      </q-btn>
                    </template>
                  </q-banner>
                </template>
                <q-banner
                  v-for="discount in order.availableDiscounts"
                  :key="discount.typeName + discount.id"
                  inline-actions
                  rounded
                  dense
                  class="full-width"
                >
                  <div class="column">
                    <div
                      class="text-subtitle1 text-weight-bold"
                      style="line-height: 1.25"
                    >
                      {{ discount.label }}
                    </div>
                    <div
                      v-if="discount.description"
                      class="text-caption"
                      style="line-height: 1"
                    >
                      {{ discount.description }}
                    </div>
                  </div>

                  <template #action>
                    <q-btn
                      v-if="discountCanBeApplied(discount) || discountApplied(order, discount)"
                      rounded
                      :icon="discountApplied(order, discount) ? 'done' : undefined"
                      :color="discountApplied(order, discount) ? 'primary' : discount.color"
                      :label="discountApplied(order, discount) ? $t('actions.applied') : $t('actions.apply')"
                      :removable="!viewOnly && discount.independent"
                      :clickable="!viewOnly"
                      @click="discountApplied(order, discount) && !viewOnly && discount.independent ? $emit('apply-discount', discount) : order.independentDiscounts.remove(discount); order.applyDiscount(discount)"
                    />
                    <q-btn
                      v-else
                      rounded
                      color="responsive-grey-2"
                      :label="$t('status.unavailable')"
                      text-color="responsive-grey-7"
                      size="sm"
                    >
                      <q-tooltip v-if="discount.reason">
                        {{ discount.reason }}
                      </q-tooltip>
                    </q-btn>
                  </template>
                </q-banner>
              </div>
            </q-item-section>
          </q-item>
        </q-card>
      </component>
    </component>
  </div>
</template>

<script>

export default {
  name: 'Redemptions',
  context: ['currentUser'],
  configuration: ['currentCircuit', 'membershipTypes'],
  inject: ['order'],
  props: {
    viewOnly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['register', 'login', 'apply-voucher', 'apply-discount'],
  data () {
    return {
      redemptionsDialog: false
    }
  },
  computed: {
    user () {
      return this.order.user
    },
    loggedIn () {
      const user = this.$kiosk ? this.user : this.currentUser

      return user && user.isRemote
    },
    showRedemptionsDetail () {
      return this.order.unappliedVouchers.length || this.order.availableDiscounts.length || this.order.availableRewards.length || (this.order.user && (this.order.unavailableRewards.length || this.order.totalPoints)) || !this.loggedIn
    },
    unavailableRewardsWithValidation () {
      if (this.$register) {
        return this.order.unavailableRewardsWithValidation
      } else {
        return this.order.unavailableRewardsWithValidationForConsumer
      }
    }
  },
  methods: {
    rewardRedeemed (order, reward) {
      return !!order.appliedVouchers.find(appliedVoucher => appliedVoucher.voucherType.id === reward.id && appliedVoucher.isReward)
    },
    numberOfRewardRedeemed (order, reward) {
      return order.appliedVouchers.filter(appliedVoucher => appliedVoucher.voucherType.id === reward.id && appliedVoucher.isReward).length
    },
    voucherRedeemed (order, voucher) {
      return !!order.uniqueAppliedVouchers.find(appliedVoucher => appliedVoucher.voucherType.id === voucher.id)
    },
    voucherCanBeApplied (voucher) {
      const orderItems = _.filter(this.order.unpaidOrderItems, orderItem => {
        // Only support one voucher
        if (orderItem.voucher || orderItem.voucherType) return false

        // When manually applying a voucher, we want to apply it to an order item that has been skipped / had it's default/automatic voucher removed
        if (!orderItem.skipVoucher) return false

        return voucher.voucherType.validateVoucher(orderItem, voucher)
      })
      return orderItems.length > 0
    },
    discountApplied (order, discount) {
      return !!order.appliedDiscounts.find(appliedDiscount => appliedDiscount.id === discount.id)
    },
    discountCanBeApplied (discount) {
      const itemsEligibleForDiscount = _.filter(this.order.unpaidOrderItems, orderItem => {
        if (orderItem.discountId !== null) return false

        if (discount.orderItemPackageOnly && !(orderItem.itemPackageId && _.includes(_.map(orderItem.itemPackage.discounts.data, 'id'), discount.id))) return false

        const discountValidation = discount.validateDiscount(orderItem, discount.orderItemPackageOnly, !this.order.isIndependentDiscount(discount), true, false)
        return discountValidation
      })
      return itemsEligibleForDiscount.length > 0
    }
  }
}

</script>
